<template>
    <div>
        <div v-if="!$route.meta?.engagementMode">
            <creator-invite-url />

            <div class="d-flex align-items-center justify-content-between mt-4">
                <h5 class="mb-0">
                    {{ $t("Invited Users") }}
                </h5>
                <b-btn-group class="">
                    <b-btn
                        :variant="
                            inviteStatus === viewOptions.key
                                ? 'primary'
                                : 'light'
                        "
                        :class="
                            inviteStatus === viewOptions.key ? '' : 'bg-white'
                        "
                        :to="`/creator/invite/${viewOptions.key}`"
                        :key="viewOptions.key"
                        v-for="viewOptions in viewOptions"
                    >
                        {{ viewOptions.label }}
                    </b-btn>
                </b-btn-group>
            </div>
        </div>

        <div class="mt-2">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import CreatorInviteUrl from "@/components/creator/invite/CreatorInviteUrl";

export default {
    data() {
        return {
            viewOptions: [
                {
                    key: "active",
                    label: this.$t("Customer"),
                },
                {
                    key: "creator",
                    label: this.$t("Creators"),
                },
                {
                    key: "inactive",
                    label: this.$t("Inactive"),
                },
            ],
        };
    },
    computed: {
        inviteStatus() {
            return this.$route.meta?.inviteStatus;
        },
        currentViewLabel() {
            return this.viewOptions.find(
                (option) => option.key === this.inviteStatus
            )?.label;
        },
    },
    methods: {
        setView(viewKey) {
            this.$store.dispatch("invitedUsers/setView", viewKey);
        },
    },
    components: {
        CreatorInviteUrl,
    },
};
</script>
